'use strict';

angular.module('ringbaPortal')
  .constant('StepperState', {
    OVER: 'over',
    BELOW: 'below',
    NORMAL: 'normal'
  })
  .directive('numberStepper',
    function (StepperState, $timeout) {
      return {
        restrict: 'A',
        templateUrl: '/scripts/shared/directives/numberstepper/numberStepper.html',
        replace: true,
        scope: {
          number: '=ngModel',
          changed: '&ngChange',
          max: '=',
          min: '=',
          step: '=',
          stateChanged: '&',
          inputClass: '@'
        },
        link: function (scope) {
          let doNotTriggerWatch = false;
          const step = scope.step || 1;

          function changeNumber(newValue) {
            if (newValue !== scope.number) {
              scope.number = newValue;
              if (angular.isFunction(scope.changed)) {
                $timeout(function() {
                  scope.changed();
                });
              }
            }
          }

          function updateState(_state, oldValue) {
            changeNumber(oldValue);

            doNotTriggerWatch = _state !== StepperState.NORMAL;

            if (angular.isFunction(scope.stateChanged)) {
              scope.stateChanged({
                state: _state,
                oldValue: oldValue
              });
            }
          }

          scope.$watch('number', function (newValue, oldValue) {
            if (!doNotTriggerWatch && newValue) {
              if (typeof newValue === 'string') {
                newValue = parseInt(newValue.replace(/\D/g, ''), 10);
              }

              if ((('undefined' === typeof scope.max) || (newValue <= scope.max)) &&
                            (('undefined' === typeof scope.min) || (newValue >= scope.min))) {
                updateState(StepperState.NORMAL, newValue);
              } else if (('undefined' !== typeof scope.max) && (newValue > scope.max)) {
                updateState(StepperState.OVER, oldValue);
              } else if ('undefined' !== typeof scope.min) {
                updateState(StepperState.BELOW, oldValue);
              }
            }
          });

          scope.increase = function () {
            if (('undefined' === typeof scope.max) || (scope.number < scope.max)) {
              updateState(StepperState.NORMAL, scope.number + step);
            } else {
              updateState(StepperState.OVER, scope.number);
            }
          };

          scope.decrease = function () {
            if (('undefined' === typeof scope.min) || (scope.number > scope.min)) {
              updateState(StepperState.NORMAL, scope.number - step);
            } else {
              updateState(StepperState.BELOW, scope.number);
            }
          };
        }
      };
    }
  );
